import conference from "../../images/Event.png"
import { Link } from "react-router-dom";
const event_info={
    name:"Consensus",
    date:"Jan 2-6, 2024 | Austin Texas"
}

export default function Hero() {
    return (
        <div className="bg-background">
            <div className="mx-auto w-screen h-99 flex-shrink-0 sm:px-6 lg:px-8">
                <div className="relative flex">
                    <img
                    src={conference}
                    className="absolute top-0 left-0 w-full h-full cursor-pointer"
                    />
                    
                    <div className="relative mb-3 flex w-full flex-col items-start justify-end bg-black bg-opacity-40 p-8 sm:p-12">
                        <div className="mt-40 pt-40">
                            <h2 className="text-4xl font-title font-bold text-white">{event_info.name}</h2>
                            <p className="mt-2 mb-4 text-base font-text text-white">
                                {event_info.date}
                            </p>
                            <Link
                                to='/purchase'
                                className="mt-4 rounded-md bg-blue px-4 py-2.5 text-sm font-text text-white"
                                onClick={() => {
                                    window.scroll(0, 1400);
                                  }}
                            >
                               To Tickets
                            </Link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

    )
}
